import { render, staticRenderFns } from "./PsiFormCurrencyTextField.vue?vue&type=template&id=3faec45f&scoped=true&"
import script from "./PsiFormCurrencyTextField.vue?vue&type=script&lang=js&"
export * from "./PsiFormCurrencyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faec45f",
  null
  
)

export default component.exports